import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import type { BaseQueryFn, FetchArgs, FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { prepareHeaders } from '../configuration/tokenHandling/prepareHeaders';

export interface ApiErrorPayload {
    status: number;
    data: {
        title?: string;
        detail?: string;
        message?: string;
    };
}

const rawBaseQuery = fetchBaseQuery({
    baseUrl: import.meta.env.VITE_API_SERVICE,
    prepareHeaders,
});

export const baseQuery: BaseQueryFn<string | FetchArgs, unknown, ApiErrorPayload> = async (args, api, extraOptions) => {
    const result = await rawBaseQuery(args, api, extraOptions);

    if (result.error) {
        const { status, data } = result.error as FetchBaseQueryError & { data?: unknown };
        const errorData = typeof data === 'object' && data !== null ? data : {};

        return {
            error: {
                status: typeof status === 'number' ? status : 500,
                data: {
                    title: (errorData as Record<string, unknown>).title as string | undefined,
                    detail: (errorData as Record<string, unknown>).detail as string | undefined,
                    message: (errorData as Record<string, unknown>).message as string | undefined,
                },
            },
        };
    }

    return { data: result.data, meta: result.meta };
};
